import { useTranslation } from "react-i18next";
import { FaConnectdevelop, FaCubes, FaDraftingCompass, FaRocket } from "react-icons/fa";

export default function Services() {
  const { t } = useTranslation();

  const items = [
    { icon: <FaDraftingCompass className="text-indigo-600" />,  i: 0 },
    { icon: <FaConnectdevelop className="text-indigo-600" />,   i: 1 },
    { icon: <FaCubes className="text-indigo-600" />,            i: 2 },
    { icon: <FaRocket className="text-indigo-600" />,           i: 3 },
  ];

  return (
    <section id="services" className="py-16 bg-white">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="text-3xl font-bold">{t("services.heading")}</h2>
        <p className="mt-2 text-slate-600">{t("services.subheading")}</p>

        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map(({ icon, i }) => (
            <div
              key={i}
              className="rounded-2xl border border-slate-200 p-6 transition-transform duration-300 hover:scale-[1.01] hover:shadow-md"
            >
              <div className="text-2xl">{icon}</div>
              <h3 className="mt-4 font-semibold">
                {t(`services.items.${i}.title`)}
              </h3>
              <p className="mt-2 text-sm text-slate-600">
                {t(`services.items.${i}.desc`)}
              </p>
            </div>
          ))}
        </div>

        {/* NEW: lifecycle note */}
        <p className="mt-6 text-sm text-slate-500">
          {t("services.note")}
        </p>
      </div>
    </section>
  );
}
